export default __webpack_public_path__ + "static/media/Patio-Moment.2cb558b2.jpg";